import { FC } from "react";
import CheckedIcon from "@mui/icons-material/CheckCircle";
import MinusIcon from "@mui/icons-material/Remove";

interface Props {
	flag?: boolean;
	size?: "inherit" | "large" | "medium" | "small";
}

/**
 * CheckedIndicator renders a "checked" icon according to the input flag.
 *
 * @param flag
 * @param size
 * @constructor
 */
const CheckedIndicator: FC<Props> = ({ flag, size = "small" }) => {
	return flag ? <CheckedIcon fontSize={size} color="primary" /> : <MinusIcon fontSize={size} />;
};

export default CheckedIndicator;
